import React, { useEffect, useRef, useState } from 'react';
import { Container, makeStyles, Grid, Button, Typography, Table, TableCell, TableRow, TableBody, Fade, Stepper, Step, StepLabel, } from '@material-ui/core';
import Page from 'components/Page';

import { FormatNumber, Header } from 'components';
import { ModalGeneral } from 'components';
// import serviciosOrden from 'utils/serviciosOrden'

import { useForm } from 'react-hook-form';
import getErrorMessage from 'utils/getErrorMessage';
import FormularioPropuesta from './FormularioPropuesta';
import FormularioSolicitud from './FormularioSolicitud';
import serviciosCatalogo from 'utils/serviciosCatalogo';
import serviciosSolicitudes from 'utils/serviciosSolicitudes';

const useStyles = makeStyles((theme) => ({
    // tabs: {
    //     backgroundColor: theme.palette.primary,
    // },
    step: {
        "&$completed": {
            color: "rgb(76,175,80)"
        },
        "&$active": {
            color: theme.palette.primary
        },
        // "&$disabled": {
        //   color: "red"
        // },
    },
    active: {}, //needed so that the &$active tag works
    completed: {},
    // disabled: {},
}));

const Propuesta = ({ setMensaje, datoS, ctls, setCargando, edicionEspecial, permisos, guardar, accion }) => {
    //inicializa variables
    const classes = useStyles();
    const formref = useRef();
    const [tabValue, setTabValue] = useState(0);
    const [mAdvertencia, setMAdvertencia] = useState({ open: false, titulo: '' });
    const [ctl, setCtl] = useState({ proyectos: [], personas: [] });
    const [data, setData] = useState({general: datoS || {}, propuesta: datoS?.propuesta || [], equipo: datoS?.equipo || [] });
    const { register, handleSubmit, errors, watch, setValue, reset, getValues, control } = useForm();


    const cerrarAdvertencia = () => setMAdvertencia({ open: false, titulo: '' });
    const abrirAdverterncia = (mensaje, dataGeneral) =>
        setMAdvertencia({
            open: true, mensaje: mensaje,
            aceptar: () => {
                clickGuardarPropuesta(dataGeneral);
                cerrarAdvertencia();
            }
        });

    const clickGuardarPropuesta = (data) => {
        guardar({ general: datoS, propuesta: data });
    }

    useEffect(() => {
        if (datoS.propuesta) {
            // setValue('recibe', null);

            // if (orden.idsupervisor) {
            //     setValue('supervisor', { idsupervisor: orden.idsupervisor, idusuario: orden.idsupervisor, nombre: orden.nsupervisor, correo: orden.correocs, telefono: orden.telefonocs });
            // } else
            //     setValue('supervisor', null);

            // setValue('condominio', { idcondominio: orden.idcondominio, ncondominio: orden.ncondominio });
            // setValue('etapa', { idetapa: orden.idetapa, netapa: orden.netapa });
            // setValue('formaPago', ctls.formaPago.find(fp => fp.cod_fpago === orden.cod_fpago));
            // setValue('homoclave', orden.homoclave);
            // setValue('proyecto', { idproyecto: orden.idproyecto, nproyecto: orden.nproyecto, siglas: orden.siglas });

            // setValue('ccosto', { idccosto: orden.idccosto, nccosto: orden.nccosto });

            // let arrGerente = ctls['gerente'].filter(ger => ger.idusuario == orden.idrecibe)[0];

            // if (accion != -1) {
            //     setData({
            //         general: {
            //             idmoneda: orden.idmoneda,
            //             ivaporcentaje: orden.ivaporcentaje,
            //             proveedor: { idproveedor: orden.idproveedor, descripcion: orden.rfcP + ' - ' + orden.nproveedor, },
            //             proyecto: { idproyecto: orden.idproyecto, nproyecto: orden.nproyecto, siglas: orden.siglas },
            //             recibe: { idrecibe: orden.idrecibe, puesto: orden.puesto, nombre: orden.nrecibe },
            //             supervisor: { idsupervisor: orden.idsupervisor, idusuario: orden.idsupervisor, nombre: orden.nsupervisor, correo: orden.correocs, telefono: orden.telefonocs }
            //         },
            //         insumos: orden.insumos
            //     })
            //     serviciosOrden.BuscarinsumosPrvCC(
            //         ct => {
            //             setCtl({ ...ctl, insumo: ct.insumo, almacen: ct.almacen, supervisor: ct.supervisores.concat(arrGerente) });
            //             ct.insumo.length == 0 && setMensaje({ open: true, status: 0, value: 'El proveedor no cuenta con insumos para este proyecto.' });
            //         },
            //         setCargando,
            //         {
            //             idproveedor: orden.idproveedor,
            //             idproyecto: orden.idproyecto,
            //             serieOrden: orden.serie,
            //             idusuario: orden.idrecibe,
            //         }
            //     );
            // }   
        }
    }, [datoS]);



    const intentodataGeneral = (dataGeneral) => {
        //advertir si una de las considciones se cumplen
        const ids = dataGeneral?.proyecto.map(pry => pry.idproyecto)||[];
        const condicion1 = !data.general.proyecto?.includes(ids); //(dataGeneral.proyecto.idproyecto != data.general?.proyecto.idproyecto);

        if (data.equipo.length > 0 && (condicion1)) {
            let mensaje = '';
            if (condicion1)
                mensaje = 'El proyecto ha sido cambiados, esto eliminara la lista de equipo asignado. ¿Desea continuar?';

            abrirAdverterncia(mensaje, dataGeneral, condicion1)
        }
        else
            guardarDataGeneral(dataGeneral, condicion1);

    }

    const guardarDataGeneral = (dataGeneral, cond1) => {
        setTabValue(1);
        //si se esta editando o al insertar no cambio el proyecto, no se buscaran personas
        if (cond1)
            serviciosSolicitudes.personasByProy((respuesta) => {
                setCtl({ ...ctl, personas: respuesta.personas });
                setData({...data,
                    general: {
                        ...data.general,
                        proyecto: dataGeneral.proyecto,
                    }
        //             // , equipo: actualizarEquipo(
        //             //     data.equipo.map(ins => ({ ...ins, tipocambio: ct.insumo.find(i => i.idinsumo == ins.idinsumo)?.tipocambio || 0 })),
        //             //     dataGeneral, { cond1, cond2, cond3, cond4 }
        //             // )
                });
            }, setCargando, { idsolicitud: data.general.idsolicitud , idproyectos: dataGeneral.proyecto.map(pry => pry.idproyecto) });
        else
            setData({
                general: {
                    ...data.general,
                    proyecto: dataGeneral.proyecto,
                }
        //         // , insumos: actualizarInsumos(
        //         //     data.insumos,
        //         //     dataGeneral, { cond1, cond2, cond3, cond4 }
        //         // )
            });
    }

    const clickGuardarOrden = () => {
        // guardar({
        //     general: {
        //         ...data.general,
        //         homoclave: data.general.homoclave2 || null,
        //         idcondominio: data.general.condominio?.idcondominio,
        //         idetapa: data.general.etapa?.idetapa,
        //         idproveedor: data.general.proveedor.idproveedor,
        //         cod_fpago: data.general.formaPago.cod_fpago,
        //         //idproyectoEtapaCondominio: data.general.condominio.idproyectoEtapaCondominio,
        //         idproyecto: data.general.proyecto.idproyecto,
        //         idrecibe: data.general.recibe.idrecibe,

        //     },
        //     insumos: data.insumos.filter(ins => ins.accion != 'ign')
        // });
    }
    //FIN Enviar a servidor
    // const bucarEquipo = (value) => {
    //     if (value){
    //         serviciosSolicitudes.equiposByProy((ct) => setCtl({ ...ctl, equipos: ct.equipos}), setCargando, { idproyectos: value.map(pry=>pry.idproyecto)});
    //     }else
    //         setCtl({ ...ctl, equipos: [] })
    // }

    const cambioPaso = (paso, nuevoData) => event => {
        setTabValue(paso);
        if (nuevoData)
            setData({ ...data, ...nuevoData });
    }
    useEffect(() => {
        register('proyecto', { required: { value: true, message: 'Campo requerido' } });
        register('desde', { required: { value: true, message: 'Campo requerido' } });
        register('hasta', { required: { value: true, message: 'Campo requerido' } });
        // register('personas', { required: { value: true, message: 'Campo requerido' } });
        register('comentario');
        //     register('condominio', { required: { value: true, message: 'Campo requerido' } });
        //     register('etapa', { required: { value: true, message: 'Campo requerido' } });
        //     register('recibe');
        //     register('supervisor');
        //     register('ccosto', {
        //         required: { value: true, message: 'Campo requerido', },
        //         validate: (value) => (ctls.centroCosto.find(cc => cc.idccosto === value.idccosto) || orden.idestatus !== "2") || 'Centro de costos desactivado'
        //     });
        //     register('homoclave');

        //     if (orden) {
        // const seleccionados=datoS.general.proyecto?.split(',')||[];
        // setValue('proyectos',ctl.proyectos.filter(pry=>seleccionados.includes(pry.idproyecto)));
        //         // option.idobra + ' - ' + option.nobra}
        //         setValue('proveedor', {
        //             idproveedor: orden.idproveedor,
        //             descripcion: orden.rfcP + ' - ' + orden.nproveedor,
        //         });
        //         if (orden.idrecibe)
        //             setValue('recibe', { idrecibe: orden.idrecibe, puesto: orden.puesto, nombre: orden.nrecibe });
        //         else
        //             setValue('recibe', null);

        //         if (orden.idsupervisor) {
        //             setValue('supervisor', { idsupervisor: orden.idsupervisor, idusuario: orden.idsupervisor, nombre: orden.nsupervisor, correo: orden.correocs, telefono: orden.telefonocs });
        //         } else
        //             setValue('supervisor', null);

        //         setValue('condominio', { idcondominio: orden.idcondominio, ncondominio: orden.ncondominio });
        //         setValue('etapa', { idetapa: orden.idetapa, netapa: orden.netapa });
        //         setValue('formaPago', ctls.formaPago.find(fp => fp.cod_fpago === orden.cod_fpago));
        //         setValue('homoclave', orden.homoclave);
        //         setValue('proyecto', { idproyecto: orden.idproyecto, nproyecto: orden.nproyecto, siglas: orden.siglas });

        //         setValue('ccosto', { idccosto: orden.idccosto, nccosto: orden.nccosto });
        //         /*
        //         if(ctls.centroCosto.find(cc => cc.idccosto === orden.idccosto)||orden.idestatus!=="2")
        //             setValue('ccosto',{idccosto:orden.idccosto,nccosto:orden.nccosto});
        //         else
        //             setValue('ccosto',null)
        //             */
        //         let arrGerente = ctls['gerente'].filter(ger => ger.idusuario == orden.idrecibe)[0];

        //         if (accion != -1) {
        //             setData({
        //                 general: {
        //                     idmoneda: orden.idmoneda,
        //                     ivaporcentaje: orden.ivaporcentaje,
        //                     proveedor: { idproveedor: orden.idproveedor, descripcion: orden.rfcP + ' - ' + orden.nproveedor, },
        //                     proyecto: { idproyecto: orden.idproyecto, nproyecto: orden.nproyecto, siglas: orden.siglas },
        //                     recibe: { idrecibe: orden.idrecibe, puesto: orden.puesto, nombre: orden.nrecibe },
        //                     supervisor: { idsupervisor: orden.idsupervisor, idusuario: orden.idsupervisor, nombre: orden.nsupervisor, correo: orden.correocs, telefono: orden.telefonocs }
        //                 },
        //                 insumos: orden.insumos
        //             })
        //             serviciosOrden.BuscarinsumosPrvCC(
        //                 ct => {
        //                     setCtl({ ...ctl, insumo: ct.insumo, almacen: ct.almacen, supervisor: ct.supervisores.concat(arrGerente) });
        //                     ct.insumo.length == 0 && setMensaje({ open: true, status: 0, value: 'El proveedor no cuenta con insumos para este proyecto.' });
        //                 },
        //                 setCargando,
        //                 {
        //                     idproveedor: orden.idproveedor,
        //                     idproyecto: orden.idproyecto,
        //                     serieOrden: orden.serie,
        //                     idusuario: orden.idrecibe,
        //                 }
        //             );
        //         }
        //         else {
        //             serviciosOrden.buscarReplica(
        //                 ct => {
        //                     setCtl({ ...ctl, insumo: ct.insumo, almacen: ct.almacen, supervisor: ct.supervisores.concat(arrGerente) })
        //                     setData({
        //                         general: {
        //                             idmoneda: orden.idmoneda,
        //                             ivaporcentaje: orden.ivaporcentaje,
        //                             proveedor: {
        //                                 idproveedor: orden.idproveedor,
        //                                 descripcion: orden.rfcP + ' - ' + orden.nproveedor,
        //                             },
        //                             proyecto: { idproyecto: orden.idproyecto, nproyecto: orden.nproyecto, siglas: orden.siglas },
        //                             recibe: { idrecibe: orden.idrecibe, puesto: orden.puesto, nombre: orden.nrecibe },
        //                             supervisor: { idsupervisor: orden.idsupervisor, idusuario: orden.idsupervisor, nombre: orden.nsupervisor, correo: orden.correocs, telefono: orden.telefonocs }
        //                         },
        //                         insumos: ct.replica
        //                     })
        //                 },
        //                 setCargando,
        //                 {
        //                     idproveedor: orden.idproveedor,
        //                     idproyecto: orden.idproyecto,
        //                     serieOrden: orden.serie,
        //                     idusuario: orden.idrecibe,
        //                     folio: orden.folio,
        //                     ivaporcentaje: orden.ivaporcentaje
        //                 }
        //             );
        //         }
        //     } else {
        //         setValue('formaPago', ctls.formaPago.find(mt => mt.cod_fpago === "99"))
        //     }
    }, [datoS]);

    useEffect(() => {
        serviciosCatalogo.proyectosAll((data) => {
            setCtl({ ...ctl, proyectos: data.proyectos });
        }, setCargando, {});
    }, []);
    return (
        <Container maxWidth={false}>
            <Stepper activeStep={tabValue} orientation="horizontal">
                <Step>
                    <StepLabel
                        StepIconProps={{
                            classes: {
                                root: classes.step,
                                completed: classes.completed,
                                active: classes.active,
                                disabled: classes.disabled
                            }
                        }}
                    >Datos solicitud</StepLabel>
                </Step>
                <Step key={1}>
                    <StepLabel
                        StepIconProps={{
                            classes: {
                                root: classes.step,
                                completed: classes.completed,
                                active: classes.active,
                                disabled: classes.disabled
                            }
                        }}
                    // optional={orden
                    //     ? <Typography variant="caption">({orden.fmodificaInsumo})</Typography>
                    //     : undefined}
                    >Propuesta </StepLabel>
                </Step>
                <Step key={2}
                    StepIconProps={{
                        classes: {
                            root: classes.step,
                            completed: classes.completed,
                            active: classes.active,
                            disabled: classes.disabled
                        }
                    }}>
                    <StepLabel>Guardar propuesta</StepLabel>
                </Step>
            </Stepper>
            <Fade in={tabValue === 0} style={{ display: tabValue === 0 ? 'block' : 'none' }}>
                <Container>
                    <form autocomplete="off" onSubmit={handleSubmit(intentodataGeneral)}>
                        <FormularioSolicitud
                            register={register}
                            errors={getErrorMessage(errors)}
                            watch={watch}
                            ctlg={{ ...ctls, proyectos: ctl.proyectos }}
                            isEdicionOrden={accion > 0}
                            // bucarEquipo={bucarEquipo}
                            defaultItem={datoS || {}}
                            setValue={setValue}
                            getValues={getValues} control={control}
                        />
                        <Grid item container justify="flex-end">
                            <Button type="submit" color="primary" ref={formref} style={{ textAlign: 'end' }}>Siguiente</Button>
                        </Grid>
                    </form>
                </Container>
            </Fade>
            <Fade in={tabValue === 1} style={{ display: tabValue === 1 ? 'block' : 'none' }}>
                <Container>
                    <form autocomplete="off" onSubmit={handleSubmit(clickGuardarPropuesta)}>
                        <FormularioPropuesta
                            register={register}
                            errors={getErrorMessage(errors)}
                            watch={watch}
                            ctlg={{ ...ctls, personas: ctl.personas }}
                            isEdicionOrden={accion > 0}
                            defaultItem={data || {}}
                            setValue={setValue}
                            getValues={getValues} control={control}
                        />
                        <Grid item container justify="space-between">
                            <Button color="secondary" onClick={cambioPaso(0,{equipo:data?.equipo})}>Atrás</Button>
                            <Button type="submit" color="primary" ref={formref} style={{ textAlign: 'end' }}>Guardar propuesta</Button>
                        </Grid>
                    </form>
                </Container>
            </Fade>
            <Fade in={tabValue === 2} style={{ display: tabValue === 2 ? 'block' : 'none' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={8}>
                        <Typography variant="subtitle1" style={{ margin: 'auto' }}>
                            Favor de verificar que todos los datos son correctos antes de guardar
                        </Typography>
                    </Grid>
                    <Grid item xs={6} md={5}>
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell variant="head" >Subtotal</TableCell>
                                    {/* <TableCell><FormatNumber value={totales.subtotal} suffix={' ' + data.general.abreviaturaMnd} type="money" /></TableCell> */}
                                </TableRow>
                                <TableRow>
                                    <TableCell variant="head" >Intercambio</TableCell>
                                    {/* <TableCell><FormatNumber value={totales.intercambiomonto} suffix={' ' + data.general.abreviaturaMnd} type="money" /></TableCell> */}
                                </TableRow>
                                <TableRow>
                                    <TableCell variant="head" >Retención IVA(4%)</TableCell>
                                    {/* <TableCell><FormatNumber value={totales.isrmonto} suffix={' ' + data.general.abreviaturaMnd} type="money" /></TableCell> */}
                                </TableRow>
                                <TableRow>
                                    <TableCell variant="head" >Retención IVA(10.67%)</TableCell>
                                    {/* <TableCell><FormatNumber value={totales.rtcArrendamientomonto} suffix={' ' + data.general.abreviaturaMnd} type="money" /></TableCell> */}
                                </TableRow>
                                <TableRow>
                                    <TableCell variant="head" >TOTAL</TableCell>
                                    {/* <TableCell><FormatNumber value={totales.importe} suffix={' ' + data.general.abreviaturaMnd} type="money" /></TableCell> */}
                                </TableRow></TableBody>
                        </Table>
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <Typography variant="subtitle1" style={{ margin: 'auto' }}>
                            ¿Desea continuar?
                        </Typography>
                    </Grid>
                    <Grid item container spacing={2}>
                        <Grid item>
                            <Button variant="text" color="secondary" className onClick={cambioPaso(1)}>Regresar</Button>
                        </Grid>
                        <Grid item>
                            <Button variant="text" color="primary" onClick={clickGuardarOrden}>Guardar Orden</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Fade>
            <ModalGeneral
                open={mAdvertencia.open}
                titulo='Advertencia'
                width='sm'
                ContenidoMensaje={mAdvertencia.mensaje}
                acciones={<React.Fragment>
                    <Button className="btnError" color="secondary" onClick={cerrarAdvertencia}>CERRAR</Button>
                    {Boolean(mAdvertencia.aceptar) &&
                        <Button color="primary" color="primary" onClick={mAdvertencia.aceptar}>ACEPTAR</Button>
                    }
                </React.Fragment>}
            />
        </Container>
    );
};

export default Propuesta;